// extracted by mini-css-extract-plugin
module.exports = {"report":"report_report__2r0r5","igtr":"report_igtr__2VxA0"};